import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment OnboardingColorCodingStep_org on Org
    @argumentDefinitions(week: { type: "LocalWeek!" }) {
      id
      experiments
      primaryOrgCalendar
      eventColoringSettingsErrorable {
        __typename

        ... on EventColoringSettings {
          eventCategoryColorings {
            active
            eventCategory
            googleColorKey
            isUserSet
          }
        }
      }
      userWorkingHours(resolveOverrides: false) {
        id
        hasBeenSet
        workingHours {
          id
          type
          timeZone
          daySettings {
            day
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
          dayOverrides {
            date
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
        }
      }
      calculateSmartHoldsErrorable(week: $week) {
        __typename
        ... on SmartHoldCalculationResult {
          smartHolds {
            title
            locked
            isClockwiseEvent
            isAllDay
            calendarIds
            organizer {
              urnValue
              responseStatus
            }
            attendees {
              urnValue
              responseStatus
            }
            creator {
              urnValue
            }
            annotatedEvent {
              userTags {
                tag
                states {
                  subjectType
                  subjectValue
                  value
                }
              }
              orgTags {
                tag
                state {
                  subjectType
                  subjectValue
                  value
                }
              }
            }
            eventKey {
              externalEventId
            }
            location
            startTime {
              dateOrDateTime
            }
            endTime {
              dateOrDateTime
            }
          }
          events {
            title
            locked
            isClockwiseEvent
            isAllDay
            calendarIds
            organizer {
              urnValue
              responseStatus
            }
            attendees {
              urnValue
              responseStatus
            }
            creator {
              urnValue
            }
            annotatedEvent {
              userTags {
                tag
                states {
                  subjectType
                  subjectValue
                  value
                }
              }
              orgTags {
                tag
                state {
                  subjectType
                  subjectValue
                  value
                }
              }
            }
            eventKey {
              externalEventId
            }
            location
            startTime {
              dateOrDateTime
            }
            endTime {
              dateOrDateTime
            }
          }
        }
      }
      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            targetUrn {
              id
              type
              value
            }
            otherUrns {
              id
              type
              value
            }
            name
            valueUrn {
              id
              type
              value
            }
            isDeleted
            options {
              syncToGoogle
            }
          }
        }
      }
    }
  `,
  user: graphql`
    fragment OnboardingColorCodingStep_user on User {
      id
      emails
      servicesFlagsErrorable {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Flags {
          flags
        }
      }
    }
  `,
};
